"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuickBetModalData = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const types_1 = require("../../providers/bet/types");
const getQuickBetModalData = (errorInfo, outcome, id) => {
    var _a;
    switch (errorInfo.code) {
        case betweb_openapi_axios_1.ErrorCode.BetsInsufficientBalance: {
            return {
                type: types_1.QuickBetModalsTypes.lowerBalance,
            };
        }
        case betweb_openapi_axios_1.ErrorCode.BetChangedCoefficient: {
            const changedCoefficients = (_a = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.details) === null || _a === void 0 ? void 0 : _a.changedCoefficients;
            if ((changedCoefficients === null || changedCoefficients === void 0 ? void 0 : changedCoefficients[0]) !== undefined) {
                return {
                    type: types_1.QuickBetModalsTypes.coefficientChanged,
                    data: {
                        newCoefficient: changedCoefficients[0].newCoefficient,
                        outcome,
                        id,
                    },
                };
            }
            return null;
        }
        default: {
            return null;
        }
    }
};
exports.getQuickBetModalData = getQuickBetModalData;
//# sourceMappingURL=bet.js.map